















































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IdentityVerification } from '@/store/consumer-application/types';
import { requiredRule, characterCountRule, notDateInFuture, notDateInPast, onlyLettersAndNumbersAllowedRule, usCitizenRule, pepRule } from '@/form-rules';

@Component
export default class IdentityVerificationFields extends Vue {
	identityVerification: IdentityVerification = {
		validIdType: '',
		idNumber: '',
		stateIssued: '',
		dateIssued: '',
		expirationDate: '',
		usCitizen: '',
		foreignOffice: ''
	};

	issueDate = '';
	dateExpired = '';

	expirationMenu = false; //for date picker
	issuedMenu = false; //for date picker

	validIdTypes = ['Driver’s License', 'Passport', 'State Issued ID w/Photo' ]

	data() {
		return {
			validIdTypeRules: [
				requiredRule('Valid ID Type is required'),
			],
			idNumberRules: [
				requiredRule('ID # is required'),
				characterCountRule('ID #', 60, 6),
				onlyLettersAndNumbersAllowedRule(),
			],
			stateIssuedRules: [
				requiredRule('State is required'),
			],
			dateIssuedRules: [
				requiredRule('Date Issued is required'),
				notDateInFuture(),
			],
			expirationDateRules: [
				requiredRule('Expiration Date is required'),
				notDateInPast(),
			],
			usCitizenRules: [
				requiredRule('Selection is required'),
				usCitizenRule('We\'re sorry. We are unable to originate your account online at this time.'),
			],
			foreignOfficeRules: [
				requiredRule('Selection is required'),
				pepRule('We\'re sorry. We are unable to originate your account online at this time.'),
			],
		};
	}
	updateIdentityVerification () {
		this.$store.commit('consumerApplication/SET_IDENTITY_VERIFICATION_FIELDS', this.identityVerification, { root: true });
	}

	formatDate (date: string | undefined) {
		if (!date) return ''
		const [year, month, day] = date.split('-')
		return `${month}/${day}/${year}`
	}

	parseDate (date: string | undefined) {
		if (!date) return ''
		const [month, day, year] = date.split('/')
		return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
	}
}
